import { useState, useEffect } from "react";
import { useAvailableFilterValues } from "../../../features/filterValues/lib/api/hooks/useAvailableFilterValues.js";
import { excludeInvalidFilterGrid } from "../../../features/filterValues/lib/excludeInvalidFilterGrid.js";
import { getFiltersFromGrid } from "../../../features/filterValues/lib/getFiltersFromGrid.js";
import { ConstructorWidgetEnum } from "../../../shared/types/constructor/widget.js";
const useAvailableFilterLocationItem = (filterRootGrid) => {
  const { data: filterValuesItem, isSuccess } = useAvailableFilterValues();
  const [availableFilterLocationItem, setAvailableFilterLocationItem] = useState(() => {
    if (!filterValuesItem || !filterRootGrid) {
      return;
    }
    const { data } = filterValuesItem;
    const adjustedGrid = excludeInvalidFilterGrid(filterRootGrid, data);
    const items = getFiltersFromGrid(adjustedGrid);
    return items.find((i) => i.type === ConstructorWidgetEnum.FilterLocation);
  });
  useEffect(() => {
    if (!isSuccess || availableFilterLocationItem || !filterRootGrid) {
      return;
    }
    const { data } = filterValuesItem;
    const adjustedGrid = excludeInvalidFilterGrid(filterRootGrid, data);
    const items = getFiltersFromGrid(adjustedGrid);
    return setAvailableFilterLocationItem(items.find((i) => i.type === ConstructorWidgetEnum.FilterLocation));
  }, [isSuccess, filterValuesItem, filterRootGrid, availableFilterLocationItem]);
  return availableFilterLocationItem;
};
export {
  useAvailableFilterLocationItem
};
